<template>

<div class="image">

    <div class="image-inner inner">

        <img :src="item.image" />

    </div>

</div>

</template>

<script>

export default {

    props: ['item']

}

</script>

<style scoped>

.image img {
    margin: 0px auto;
    width: auto;
    max-width: 100%;
}

</style>
